import { useEffect, useCallback, useState } from 'react';
import React from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { Spin, Table, message, Drawer, Button, Modal } from 'antd';

import sessionManager, { eVariableType } from '../../SessionManager';
import api from '../../api';
import stringres from '../../translations/stringres';
import ClienteAddEdit from './ClienteAddEdit';
import ClienteScheda from './ClienteScheda';

export default function ClientiGrid(props) {
    const { ragioneSociale } = props;

    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentRow, SetCurrentRow] = useState(null);

    const fetchData = useCallback(
        async (cpage) => {
            setIsLoading(true);

            try {
                let sRag = '';

                if (ragioneSociale !== null && ragioneSociale !== '')
                    sRag = '&ragioneSociale=' + encodeURIComponent(ragioneSociale);

                const result = await api.get(
                    'CRM/clienti?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&indice=' +
                        (cpage - 1) * pageSize +
                        '&numeroRecord=' +
                        pageSize +
                        sRag
                );

                if (result != null) {
                    if (Array.isArray(result.data) && result.data.length > 0) {
                        setData(result.data);
                        setTotalPages(Math.floor(result.data[0].totaleRighe / pageSize));
                    } else {
                        setData(null);
                        setTotalPages(1);
                        setCurrentPage(1);
                    }
                }
            } catch (errorx) {
                message.error('An error occured!' + errorx, 5);
            } finally {
                setIsLoading(false);
            }
        },
        [pageSize, props]
    );

    useEffect(() => {
        fetchData(currentPage);
    }, [fetchData, currentPage, ragioneSociale]);

    const columns = [
        {
            title: stringres.t('codCliente'),
            dataIndex: 'codCliente',
            sorter: (a, b) => a?.codCliente.localeCompare(b?.codCliente),
        },
        {
            title: stringres.t('ragioneSociale'),
            dataIndex: 'ragioneSociale',
            sorter: (a, b) => a?.ragioneSociale.localeCompare(b.ragioneSociale),
            render: (text, record) => (
                <button className="link-button" onClick={() => showModal(record)}>
                    {text}
                </button>
            ),
        },
        { title: stringres.t('piva'), dataIndex: 'partitaIva' },
        { title: stringres.t('email'), dataIndex: 'email' },
        { title: stringres.t('telefono'), dataIndex: 'telefono' },
        {
            title: stringres.t('nazione'),
            dataIndex: 'codNazione',
            onFilter: (value, record) => record?.codNazione.startsWith(value),
            filterSearch: true,
            filters: [...new Set(data?.map((x) => x.codNazione))].map((nazione) => ({ text: nazione, value: nazione })),
        },
        { title: stringres.t('localita'), dataIndex: 'localita' },
        {
            title: '',
            width: 20,
            dataIndex: 'delete',
            render: (text, record) =>
                record?.isProspect ? (
                    <Button loading={isLoadingDelete} onClick={() => onDelete(record)}>
                        <DeleteOutlined />
                    </Button>
                ) : null,
        },
    ];

    async function onDelete(rec) {
        try {
            setIsLoadingDelete(true);
            if (rec != null) {
                const result = await api.delete(
                    'CRM/Clienti/DeleteProspect?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&codCliente=' +
                        rec.codCliente
                );
                if (result.status === 200) {
                    message.success(stringres.t('successo'));

                    fetchData();
                } else message.error(result.statusText);
            }
        } catch (error) {
            message.error(error.response.data.message, 5);
        } finally {
            setIsLoadingDelete(false);
        }
    }

    const showModal = (record) => {
        SetCurrentRow(record);
        setIsModalOpen(true);
    };

    const handlePageChange = (page, pSize) => {
        setCurrentPage(page);
        setPageSize(pSize);
        if (data != null && data.length > 0) setTotalPages(Math.floor(data[0].totaleRighe / pSize));
    };
    const handlePageSizeChange = (current, size) => {
        setPageSize(size);
        setCurrentPage(1);
    };

    function onCancelEdit() {
        setIsEditOpen(false);
        setIsModalOpen(false);
    }
    const pagination = {
        current: currentPage,
        pageSize: pageSize,
        total: totalPages * pageSize,
        onChange: handlePageChange,
        onShowSizeChange: handlePageSizeChange,
    };
    const onChange = (pagination, filters, sorter, extra) => {};
    const rowKeys = ['codCliente', 'idProspect'];

    return (
        <div>
            <Spin spinning={isLoading} size="large">
                <Table
                    scroll={{ x: 'max-content' }}
                    responsive
                    rowKey={(row) => rowKeys.map((key) => row[key]).join('-')}
                    columns={columns}
                    dataSource={data}
                    pagination={pagination}
                    onChange={onChange}
                ></Table>
            </Spin>
            <Drawer
                destroyOnClose="true"
                open={isModalOpen}
                width="90%"
                title={
                    <span className="App-title-dark">
                        {stringres.t('schedaCliente') + ': ' + currentRow?.ragioneSociale}
                    </span>
                }
                onClose={() => setIsModalOpen(false)}
                style={{ backgroundColor: '#eef2f4' }}
            >
                <ClienteScheda cliente={currentRow}></ClienteScheda>
            </Drawer>
            <Modal
                destroyOnClose="true"
                title={stringres.t('elencodaticliente')}
                bodyStyle={{ marginTop: '20px' }}
                width={'50%'}
                footer={null}
                open={isEditOpen}
                onCancel={() => setIsEditOpen(false)}
                onOk={() => setIsEditOpen(false)}
            >
                <ClienteAddEdit onCancel={onCancelEdit}></ClienteAddEdit>
            </Modal>
        </div>
    );
}
